// extracted by mini-css-extract-plugin
export default {"container":"ConsentPage_container__8XWa-","checkbox":"ConsentPage_checkbox__ulksW","loading":"ConsentPage_loading__irMb-"};